import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useGameDetails } from './use-game-details';
import { fetchGameDetails } from 'modules/games/store/actions';

export const useGameDetailsFetch = (gameId: number) => {
  const  dispatch = useDispatch();
  const { isLoading } = useGameDetails();

  useEffect(() => {
    if (!isLoading) {
      dispatch(fetchGameDetails({ gameId }));
    }
  }, [gameId]);
};
